export default function WhyUKSection() {
  return (
    <section className="relative py-20 md:py-28 bg-white overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20London%20skyline%20view%20with%20the%20City%20financial%20district%2C%20modern%20glass%20skyscrapers%20reflecting%20warm%20morning%20sunlight%2C%20historic%20and%20contemporary%20architecture%20blend%2C%20premium%20landscape%20photography%2C%20bright%20and%20serene%20atmosphere%2C%20professional%20editorial%20quality&width=800&height=600&seq=uk-london-skyline-001&orientation=landscape"
                alt="London Skyline – Bounds Green, London, United Kingdom"
                className="w-full h-auto object-cover rounded-2xl"
              />
              {/* Caption badge */}
              <div className="absolute bottom-5 left-5 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2.5">
                <p className="text-xs text-foreground-700 font-medium">Bounds Green, London, United Kingdom</p>
                <p className="text-[10px] text-foreground-400 uppercase tracking-[1.5px]">Our Headquarters</p>
              </div>
            </div>

            {/* Subtle decorative element */}
            <div className="absolute -top-8 -right-8 w-32 h-32 border border-primary-300/30 rounded-full hidden lg:block" />
            <div className="absolute -bottom-8 -left-8 w-24 h-24 border border-primary-300/20 rounded-full hidden lg:block" />
          </div>

          {/* Right - Content */}
          <div>
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              UK Governance
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-6 tracking-tight">
              British Standards.<br />Global Diversification.
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-6">
              Headquartered at 12 Gateway Mews in Bounds Green, London, our firm embodies the British tradition of transparency, stability, and institutional excellence. Registered as a private limited company under Company No. 10256484 with Companies House, we operate with the highest standards of governance and accountability.
            </p>
            <p className="text-foreground-500 text-base leading-relaxed mb-8">
              From our London base, we deploy capital across 18 countries and five diversified sectors — combining local market expertise with rigorous British oversight. Every investment is evaluated through a disciplined, research-driven framework.
            </p>

            {/* Mini stat cards */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { value: '2016', label: 'Founded' },
                { value: 'Ltd', label: 'Legal Structure' },
                { value: '10256484', label: 'Company No.' },
                { value: '18', label: 'Countries Active' },
              ].map((s) => (
                <div key={s.label} className="bg-background-50 rounded-xl px-5 py-4 border border-foreground-100/20">
                  <p className="text-2xl font-heading font-bold text-foreground-950">{s.value}</p>
                  <p className="text-[10px] uppercase tracking-[1.5px] text-foreground-400 mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>

            <a
              href="/about"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm uppercase tracking-[2px] font-semibold transition-colors cursor-pointer"
            >
              Learn More About Us
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}